<template>
  <div class="tile">
    <a class="tile__link" :href="tileLink">
      <Picture :images="tileImage" />
    </a>
    <div class="tile__info">
      <a class="tile__link" :href="tileLink">
        <h3 class="tile__heading">{{ tileTitle }}</h3>
      </a>
      <AddToBagTile
        v-if="product"
        :price="price"
        :original-price="originalPrice"
        @click="handleAddToBag"
      />
    </div>
  </div>
</template>

<script>
import AddToBagTile from "@/components/add-to-bag/AddToBagTile.vue";
import Picture from "@/components/Picture.vue";
import { unwrapNodes } from "@/helpers/graphql";
import { mapActions } from "vuex";

export default {
  name: "PhotoTile",
  components: {
    Picture,
    AddToBagTile,
  },
  props: {
    imageUrl: {
      type: Object,
      default: null,
    },
    link: {
      type: String,
      default: null,
    },
    productId: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    product: {
      type: Object,
      default: () => {},
    },
    flatLays: {
      type: Boolean,
      default: false,
    },
    useEditorialPhoto: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      openAddedToBag: false,
      variantId: null,
    };
  },
  computed: {
    tileLink() {
      return this.product ? this.product.onlineStoreUrl : this.link;
    },
    tileTitle() {
      return this.product ? this.product.title : this.title;
    },
    tileImage() {
      if (this.imageUrl) {
        console.log("gaia", this.imageUrl);
        return this.imageUrl;
      }

      const editorialPhoto = this.product.editorialMedia;
      if (this.useEditorialPhoto && editorialPhoto) {
        console.log("gaia", editorialPhoto.reference.image.largeMedia);
        return editorialPhoto.reference.image;
      }

      const flatLayImages =
        unwrapNodes(this.product.flatlays?.references?.edges) || [];

      const standardImages = unwrapNodes(this.product.images?.edges) || [];

      if (this.flatLays && flatLayImages.length > 0) {
        return flatLayImages ? flatLayImages[0].image : null;
      } else {
        return standardImages ? standardImages[0] : null;
      }
    },
    price() {
      return this.product.priceRange.minVariantPrice;
    },
    originalPrice() {
      return this.product.compareAtPriceRange.minVariantPrice;
    },
    variants() {
      const variants = unwrapNodes(this.product?.variants.edges);
      return variants || null;
    },
    selectedVariant() {
      return this.variants.find((variant) => variant.id === this.variantId);
    },
  },
  methods: {
    ...mapActions("add-to-bag", ["openAddToBag"]),
    handleAddToBag() {
      if (this.variants.length > 0) {
        this.openAddToBag(this.product);
      } else {
        console.error("Product has no variants", this.variants);
      }
      //Todo: Force add to bag if no variants
    },
  },
};
</script>

<style lang="scss" scoped>
.tile {
  display: block;
  position: relative;

  &__info {
    font-size: 9px;
    position: absolute;
    bottom: 5px;
    left: 0;
    right: 0;
    padding: 0 15px 15px;
    color: $color-white;
    text-align: left;

    @include respond-above(md) {
      font-size: 10px;
      padding: 0 20px 20px;
    }

    ::v-deep(.button) {
      padding: 0;
    }
  }

  &__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &__link {
    color: $color-white;
    display: block;
    height: 100%;
    line-height: 0;
    text-decoration: none;
  }

  &__heading {
    color: $color-white;
    font-size: 12px;
    font-weight: 700;
    line-height: normal;
    padding: 0;
    margin: 0 0 10px 0;
    text-transform: uppercase;

    @include respond-above(md) {
      font-size: 18px;
    }
  }

  &::v-deep(.picture__wrapper) {
    &:after {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      display: inline-block;
      background: linear-gradient(
        to top,
        rgba(0, 0, 0, 0.75) 0%,
        rgba(0, 0, 0, 0) 20%
      );
    }
  }
}
</style>
